import { useEffect } from 'react'
import { useDragLayer } from 'react-dnd'

export function CustomDragLayer() {
	const { isDragging, currentOffset } = useDragLayer((monitor) => ({
		isDragging: monitor.isDragging(),
		currentOffset: monitor.getSourceClientOffset(),
	}))

	useEffect(() => {
		if (isDragging) {
			document.body.classList.add('dragging')
		} else {
			document.body.classList.remove('dragging')
		}
	}, [isDragging])

	if (!isDragging || !currentOffset) return null

	return (
		<div
			style={{
				position: 'fixed',
				left: currentOffset.x, // ajuste fino horizontal
				top: currentOffset.y, // ajuste fino vertical
				pointerEvents: 'none',
				zIndex: 9999,
			}}
		>
			<img
				src="./assets/cursor/cursor_clicado.png"
				alt="cursor de arrasto"
				width={40}
				height={40}
				style={{
					imageRendering: 'pixelated',
					userSelect: 'none',
				}}
			/>
		</div>
	)
}
